import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { callstackSlice, selectCallstack, selectCallstackIsPlaying } from "#/features/callstack/model/callstackSlice";
import { editorSlice, selectIsEditingNodes } from "#/features/treeViewer/model/editorSlice";
import { useAppDispatch, useAppSelector, useAppStore } from "#/store/hooks";
import { getLastRenderableFrameIndex, getNextPlaybackFrameIndex, getPreviousPlaybackFrameIndex, resetStructuresState } from "../lib";
export const usePlayerControls = () => {
  const $ = _c(29);
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const isEditingNodes = useAppSelector(selectIsEditingNodes);
  let t0;
  if ($[0] !== dispatch) {
    t0 = () => {
      resetStructuresState(dispatch, false);
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleReset = t0;
  let t1;
  if ($[2] !== dispatch || $[3] !== handleReset) {
    t1 = () => {
      handleReset();
      dispatch(callstackSlice.actions.setFrameIndex(-1));
      dispatch(callstackSlice.actions.setIsPlaying(true));
    };
    $[2] = dispatch;
    $[3] = handleReset;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleReplay = t1;
  let t2;
  if ($[5] !== dispatch || $[6] !== store) {
    t2 = () => {
      const callstack = selectCallstack(store.getState());
      const frameIndex = callstack.frameIndex;
      if (frameIndex === -1) {
        return;
      }
      dispatch(callstackSlice.actions.setFrameIndex(getPreviousPlaybackFrameIndex(callstack.frames, frameIndex)));
    };
    $[5] = dispatch;
    $[6] = store;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleStepBack = t2;
  let t3;
  if ($[8] !== dispatch || $[9] !== store) {
    t3 = () => {
      const callstack_0 = selectCallstack(store.getState());
      const isPlaying = selectCallstackIsPlaying(store.getState());
      const frameIndex_0 = callstack_0.frameIndex;
      const lastRenderableFrameIndex = getLastRenderableFrameIndex(callstack_0.frames);
      if (frameIndex_0 >= lastRenderableFrameIndex) {
        return;
      }
      dispatch(callstackSlice.actions.setIsPlaying(!isPlaying));
    };
    $[8] = dispatch;
    $[9] = store;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handlePlay = t3;
  let t4;
  if ($[11] !== dispatch || $[12] !== store) {
    t4 = () => {
      const callstack_1 = selectCallstack(store.getState());
      const frameIndex_1 = callstack_1.frameIndex;
      const nextFrameIndex = getNextPlaybackFrameIndex(callstack_1.frames, frameIndex_1);
      if (nextFrameIndex === -1) {
        return;
      }
      dispatch(callstackSlice.actions.setFrameIndex(nextFrameIndex));
    };
    $[11] = dispatch;
    $[12] = store;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleStepForward = t4;
  let t5;
  if ($[14] !== dispatch || $[15] !== handlePlay || $[16] !== handleReplay || $[17] !== handleReset || $[18] !== handleStepBack || $[19] !== handleStepForward || $[20] !== isEditingNodes) {
    t5 = event => {
      if (isEditingNodes) {
        if (event.key === "Escape") {
          dispatch(editorSlice.actions.setIsEditing(false));
        }
        return;
      }
      if (event.key === "ArrowLeft") {
        handleStepBack();
      } else {
        if (event.key === "ArrowRight") {
          handleStepForward();
        } else {
          if (event.key === " ") {
            if (event.target instanceof HTMLInputElement || event.target instanceof HTMLButtonElement) {
              return;
            }
            handlePlay();
          } else {
            if (event.key === "r") {
              handleReplay();
            } else {
              if (event.key === "Escape") {
                handleReset();
              }
            }
          }
        }
      }
    };
    $[14] = dispatch;
    $[15] = handlePlay;
    $[16] = handleReplay;
    $[17] = handleReset;
    $[18] = handleStepBack;
    $[19] = handleStepForward;
    $[20] = isEditingNodes;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const handleKeyDown = t5;
  let t6;
  if ($[22] !== handleKeyDown || $[23] !== handlePlay || $[24] !== handleReplay || $[25] !== handleReset || $[26] !== handleStepBack || $[27] !== handleStepForward) {
    t6 = {
      handleReset,
      handleReplay,
      handleStepBack,
      handlePlay,
      handleStepForward,
      handleKeyDown
    };
    $[22] = handleKeyDown;
    $[23] = handlePlay;
    $[24] = handleReplay;
    $[25] = handleReset;
    $[26] = handleStepBack;
    $[27] = handleStepForward;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  return t6;
};